module.exports = __webpack_public_path__ + "media/images/suppliers/sdix-a8adf2132fa3d91ef18ad45a3a9730de.png";